import { types } from '@/store/types';
import { DEFAULT_LOCALE } from '@/constants/locale';

export const getInitialState = () => ({
  [types.state.TOKEN]: null,
  [types.state.HASHED_DATA_ID]: null,
  [types.state.INITIAL_PAGE_DATA]: null,
  [types.state.PATIENT_SKIN_DATA]: null,
  [types.state.SERUM_INCI_LISTS]: null,
  [types.state.DYSFUNCTIONS_DATA]: null,
  [types.state.TREATMENT_DATA]: null,
  [types.state.SELECTED_EYE_SERUM_GENERIC_FORMULA_ID]: '',
  [types.state.EYE_CONTOUR_SERUM_GENERIC_FORMULAS_LIST]: [],
  [types.state.RECOMMENDED_PRODUCT_NAMES]: [],
  [types.state.PRICES]: null,
  [types.state.CART]: [],
  [types.state.IS_CART_OPEN]: false,
  [types.state.DELIVERY_DATA]: null,
  [types.state.DELIVERY_TYPE]: null,
  [types.state.STOCK]: null,
  [types.state.LOCALE]: DEFAULT_LOCALE,
  [types.state.IS_LOADING]: false,
  [types.state.AVAILABLE_DELIVERY_COUNTRIES]: null,
  [types.state.PROMO_CODE_DATA]: null,
  [types.state.TRUSTPILOT_DATA]: null,
  [types.state.TRUSTPILOT_REVIEWS]: []
});
